import {ISvgIconProps, SvgIcon} from "../../../basic-ui-components/icon/svg-icon/svg.icon";
import * as React from "react";

export class WalletIcon extends React.Component<ISvgIconProps> {

    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 24 24" >
                <g fill="currentColor">
                    <path d="M20.348,10.903V9c0-0.992-0.842-1.8-1.878-1.8h-2.423l-4.048-3.448C11.883,3.654,11.735,3.6,11.582,3.6
                        s-0.301,0.054-0.416,0.151L7.118,7.2H5.53c-1.726,0-3.13,1.346-3.13,3v7.2c0,1.654,1.404,3,3.13,3h12.939
                        c1.036,0,1.878-0.808,1.878-1.8v-1.903c0.729-0.247,1.252-0.915,1.252-1.697v-2.4C21.6,11.818,21.076,11.151,20.348,10.903z
                        M11.583,5.002L14.162,7.2H9.003L11.583,5.002z M19.096,18.6c0,0.331-0.281,0.6-0.626,0.6H5.53c-1.036,0-1.878-0.808-1.878-1.8v-7.2
                        c0-0.992,0.843-1.8,1.878-1.8h12.939c0.345,0,0.626,0.269,0.626,0.6v1.8h-1.878c-1.726,0-3.13,1.346-3.13,3c0,1.654,1.404,3,3.13,3
                        h1.878L19.096,18.6L19.096,18.6z M20.348,15c0,0.331-0.281,0.6-0.626,0.6h-2.504c-1.035,0-1.878-0.808-1.878-1.8
                        c0-0.992,0.843-1.8,1.878-1.8h2.504c0.345,0,0.626,0.269,0.626,0.6V15z M17.217,13.2c-0.346,0-0.626,0.269-0.626,0.6
                        c0,0.331,0.28,0.6,0.626,0.6s0.626-0.269,0.626-0.6C17.843,13.469,17.563,13.2,17.217,13.2z"/>
                </g>
           </SvgIcon>
        )
    }
}